import React from 'react';
import { useAnalytics } from '../recs/analytics';
import './MouseTrail.css';

export default function MouseTrail() {
  const { mouseTrailEnabled, mousePoints } = useAnalytics();
  if (!mouseTrailEnabled) return null;

  return (
    <div className="mouse-trail" aria-hidden="true">
      {mousePoints.map((point, i) => (
        <span
          key={point.t + '-' + i}
          className="mouse-trail__dot"
          style={{
            left: point.x,
            top: point.y,
            opacity: (i + 1) / mousePoints.length,
          }}
        />
      ))}
    </div>
  );
}
